import React, { useEffect } from "react";
import GlossaryContainer from "./glossary_container";
import Header from "../login-register/components/header";

const GlossaryPage = (props) => {
    useEffect(() => {
        document.title = "Glossary";
        var link = !document.querySelector("link[rel='canonical']")
            ? document.querySelector("link[rel='canonical']")
            : document.createElement("link");
        link.setAttribute("rel", "canonical");
        link.setAttribute(
            "href",
            document.location.protocol +
                "//" +
                document.location.host +
                document.location.pathname,
        );
        document.head.appendChild(link);
    }, []);

    return (
        <>
            {props.dontShowHeader ? null : (
                <Header showLogin={true} showIntro={true} />
            )}
            <GlossaryContainer></GlossaryContainer>
        </>
    );
};

export default GlossaryPage;
